<template>
  <div class="d-flex flex-column align-center"
       @keyup.enter.prevent="handleRegistration"
  >
    <div class="d-flex flex-column align-center">
      <img :src="logo" alt="Anty Logo" />
      <p
        class="auth-registration-form-title text-primary--text mt-8 mb-0 d-flex align-center justify-center"
        v-html="$t('auth.registration.headerTitle', waveEmoji)"
      ></p>
      <p class="auth-registration-form-text ma-0 mt-2 text-caption--text">
        {{ $t('auth.registration.formText') }}
      </p>
    </div>
    <div
      class="auth-registration-form d-flex flex-column justify-center align-center"
    >
      <div class="auth-registration-form-container mt-8">
        <!--EMAIL-->
        <auth-input
          :value="registrationForm.username"
          :placeholder-and-label="emailPlaceholderAndLabel"
          :required="true"
          :necessary="true"
          :handle-change-value="changeInputValue"
          :error-state="{
            errorMessage: email,
            errorStatus: Boolean(email)
          }"
        />
        <!--PASSWORD-->
        <auth-input
          :value="registrationForm.password"
          :placeholder-and-label="passwordPlaceholderAndLabel"
          :necessary="true"
          :required="true"
          type="password"
          :handle-change-value="changeInputValue"
          @focus="showValidation"
          :error-state="{
            errorMessage: password,
            errorStatus: Boolean(password)
          }"
        >
          <div v-show="showPasswordValidation">
          <password-validation
            :password="registrationForm.password"
            @setPasswordState="setPasswordState"
          />
          </div>
        </auth-input>
        <!--TELEGRAM-->
        <auth-input
          :value="registrationForm.telegram"
          :placeholder-and-label="telegramPlaceholderAndLabel"
          :handle-change-value="changeInputValue"
        />
        <!--PROMO CODE-->
        <auth-input
          :value="registrationForm.promo"
          :placeholder-and-label="promoPlaceholderAndLabel"
          :handle-change-value="changeInputValue"
          :error-state="{
            errorMessage: promo,
            errorStatus: Boolean(promo)
          }"
          @blur="checkPromoCode"
          :success-message="promoSuccess"
        />
        <!--CAPTCHA START-->
        <div
          v-if="showCaptcha"
          class="captcha"
        >
          <captcha-wrapper
            captcha-id="registration-captcha"
            :captcha-type="captchaType"
            @handle-captcha-response="handleCaptchaResponse"
          />
        </div>
        <!--CAPTCHA END-->

        <!-- NEWSLETTER AND AGREEMENT CHECKBOX -->
        <div class='d-flex flex-column'>
          <div class="d-flex align-center auth-registration-agreement mb-2">
            <auth-check-box
              :active="registrationForm.newsletter"
              @toggleChecked="toggleNewsletter"
            />
            <label
              class="ma-0 auth-agreement-checkbox-label"
              @click="toggleNewsletter"
            >
              {{ $t("common.newsletter") }}
            </label>
          </div>

          <div class="d-flex align-center auth-registration-agreement">
            <auth-check-box
              :active="agreementCheckbox"
              @toggleChecked="toggleAgreement"
              :error-check-box="errorBox"
            />
            <auth-label
              @toggleAgreement="toggleAgreement"
              :agreement-checkbox="agreementCheckbox"
              :error-box="errorBox"
            />
          </div>
        </div>
        <auth-button
          type="submit"
          :loading="loading"
          @handleClick="handleRegistration"
        >
          {{ $t('auth.registration.registrationButton') }}
        </auth-button>
        <p
          class="align-self-center link-primary-text-default--text auth-registration-login-link"
          @click="$router.push('/auth/login')"
        >
          {{ $t('auth.registration.loginLink') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AuthInput from '@/components/auth/components/AuthInput.vue'
import AuthButton from '@/components/auth/components/AuthButton.vue'
import PasswordValidation from '@/components/auth/components/PasswordValidation.vue'
import AuthCheckBox from '@/components/auth/components/AuthCheckBox.vue'
import logo from '@/assets/antyLogo.svg'
import waveHand from '@/assets/auth/waveEmoji.png'
import CaptchaWrapper from '@/components/CaptchaWrapper.vue'
import { MT_CAPTCHA_NAME } from '@/constants/auth/captcha'
import captcha from '@/mixins/captcha'
import AuthLabel from '@/components/auth/components/AuthLabel.vue'
import Cookies from 'js-cookie'

export default {
  name: 'AuthRegistration',

  components: {
    AuthLabel,
    CaptchaWrapper,
    AuthCheckBox,
    PasswordValidation,
    AuthButton,
    AuthInput
  },

  mixins: [ captcha ],

  data() {
    return {
      logo,
      registrationForm: {
        username: '',
        password: '',
        telegram: '',
        promo: '',
        captcha: null,
        newsletter: true
      },
      count: parseInt(localStorage.getItem('requestEmailVerificationCount'), 10) || 0,
      email: '',
      promo: '',
      password: '',
      promoSuccess: '',
      passwordState: false,
      agreementCheckbox: false,
      errorBox:false,
      loading: false,
      showPasswordValidation: false,
      showCaptcha: false,
      captchaType: MT_CAPTCHA_NAME
    }
  },

  computed: {
    waveEmoji () {
      return [
        `<img src="${waveHand}" alt="Waving Hand"  width="20px" height="20px" style="margin-left: 4px"/>`
      ]
    },

    passwordPlaceholderAndLabel() {
      return {
        label: 'auth.registration.passwordLabel',
        placeholder: 'auth.registration.passwordPlaceholder',
        name: 'password'
      }
    },

    emailPlaceholderAndLabel() {
      return {
        label: 'auth.registration.emailLabel',
        placeholder: 'auth.registration.emailPlaceholder',
        name: 'username'
      }
    },

    telegramPlaceholderAndLabel() {
      return {
        label: 'auth.registration.telegramLabel',
        placeholder: 'auth.registration.telegramPlaceholder',
        name: 'telegram'
      }
    },

    promoPlaceholderAndLabel() {
      return {
        label: 'auth.registration.promoLabel',
        placeholder: 'auth.registration.promoPlaceholder',
        name: 'promo'
      }
    }
  },

  mounted() {
    localStorage.setItem('requestEmailVerificationCount', 0)
  },

  methods: {
    async checkPromoCode() {
      if (!this.registrationForm.promo) return
      this.promoSuccess = ''
      this.promo=''

      try {
        const response = await this.$store.dispatch('auth/checkPromo', this.registrationForm.promo)

        if (response.status === 200) {
          if (response.data.data.exists) {
            this.promoSuccess = 'auth.registration.successfullyPromo'
          } else {
            this.promo = 'auth.registration.promoError'
          }
        }
      } catch (e) {
        console.log(e.response)
        this.promo = 'auth.registration.promoError'
      }
    },

    handleCaptchaResponse (verifiedToken) {
      this.registrationForm.captcha = verifiedToken
    },

    showValidation() {
      this.showPasswordValidation = true
    },

    clearErrorMessages() {
      this.email = ''
      this.password = ''
      this.errorBox= false
    },

    async handleRegistration() {
      this.registrationForm.username = this.registrationForm.username.trim()

      const { username, password } = this.registrationForm

      if (username.trim() === '' || password.trim() === '' || !this.agreementCheckbox) {
        this.clearErrorMessages()

        if (username.trim() === '' && password.trim() === '' && !this.agreementCheckbox) {
          this.email = 'auth.login.requiredField'
          this.password = 'auth.login.requiredField'
          this.errorBox = true
        }

        if (username.trim() === '') {
          this.email = 'auth.login.requiredField'
        }

        if (password.trim() === '') {
          this.password = 'auth.login.requiredField'
        }

        if (!this.agreementCheckbox) {
          this.errorBox = true
        }

        return
      }

      this.clearErrorMessages()

      if (!this.passwordState) return

      this.loading = true

      try {
        localStorage.setItem('requestEmailVerificationCount', this.count)

        await this.$store.dispatch('auth/getRegistrationToken', this.registrationForm)

        const accessToken = localStorage.getItem('confirmToken')
        const refreshToken = localStorage.getItem('confirmRefreshToken')

        await this.$store.dispatch('main/loadProfileForVerification', { accessToken, refreshToken })
        await this.$store.dispatch('auth/sendEmailVerificationNotification', { accessToken, count: this.count })
        try {
          await this.$analytics.track('sign_up')
        } catch (e) {
          console.info('analytics error: ', e)
        }

        try {
          await this.$metrika.reachGoal('registration')
        } catch (e) {
          console.info('metrika error: ', e)
        }
        await this.$router.push({
          name: 'ConfirmEmail',
          query: {
            username: this.registrationForm.username,
            count: this.count
          }
        })
      } catch (e) {
        if (this.showCaptcha) {
          this.resetCaptcha(this.captchaType, 'forgot-password-captcha', this.handleResetHcaptcha)
        }
        console.error('An error occurred',e)

        this.handleRegistrationError(e)
      } finally {
        this.loading = false
      }
    },

    handleResetHcaptcha () {
      this.$refs?.captchaWrapper.$refs.captcha?.reset()
    },

    handleRegistrationError(e) {
      const { status, data } = e.response || {}

      if (status === 422) {
        this.handle422Error(data)
      } else if (status === 404 && data?.error?.type === 'E_PROMO') {
        this.promo = 'auth.registration.promoError'
      } else if (status === 400) {
        this.showCaptcha = true
        this.captchaType = e.response.data
      }
    },

    handle422Error(data) {
      const { field, error } = data?.error?.fields[0] || {}

      if (field === 'username') {
        this.handleUsernameError(error)
      }
    },

    handleUsernameError(error) {
      if (error === 'email') {
        this.email = 'auth.registration.emailError'
      } else if (error === 'unique') {
        this.email = 'auth.registration.emailUniqueError'
      }
    },

    setPasswordState(state) {
      this.passwordState = state
    },

    toggleAgreement(evt) {
      // Don't toggle if user clicked on agreement link
      if (evt.target.tagName.toLowerCase() === 'a') return

      this.agreementCheckbox = !this.agreementCheckbox
    },

    toggleNewsletter() {
      this.registrationForm = {
        ...this.registrationForm,
        newsletter: !this.registrationForm.newsletter
      }
    },

    changeInputValue(value, type) {
      this.registrationForm[type] = value
    }
  }
}
</script>

<style lang="scss">
.auth-registration-root {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 48px);
}

.auth-registration-form {
  font-family: Roboto, sans-serif;
  width: 400px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.auth-registration-agreement {
  gap: 10px;
}

.auth-registration-form-title {
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.auth-registration-form-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.auth-registration-login-link {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
  cursor: pointer;
}

.auth-agreement-checkbox-label {
  color: var(--v-text-secondary-base);
  cursor: pointer
}
</style>
